
// $FlowFixMe
import { useContext } from 'react';
import { combineRules } from 'fela';

import { RendererContext, ThemeContext } from './context';

export default function useFela() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var renderer = useContext(RendererContext);
  var theme = useContext(ThemeContext) || {};

  if (!renderer) {
    throw new Error('The "useFela" hook can only be used  inside a "RendererProvider"');
  }

  var propsWithTheme = { theme: theme };
  if (props) Object.assign(propsWithTheme, props);

  function css() {
    return renderer.renderRule(combineRules.apply(undefined, arguments), propsWithTheme);
  }

  return {
    renderer: renderer,
    theme: theme,
    css: css
  };
}